import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject, OnInit,
    ViewEncapsulation
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { KAL_DIALOG_DATA, KalDialogRef } from '@kalidea/kaligraphi';
import isEqual from 'lodash-es/isEqual';
import { throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { BaseComponent } from 'src/app/_core/tools/base.component';
import { UserDelegation } from 'src/app/_user/components/user-delegation-picker/user-delegation-picker.component';
import {
    GetFunctionalitiesAndWidgetsAccessibleAction,
    SaveUserLoginInformationsAction
} from 'src/app/_user/store/user/user.action';

export interface UserDelegationPickerDialogData {
    accepted?: boolean;
    currentDelegationData?: UserDelegation;
}

@Component({
    selector: 'app-user-delegation-picker-dialog',
    templateUrl: './user-delegation-picker-dialog.component.html',
    styleUrls: ['./user-delegation-picker-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UserDelegationPickerDialogComponent extends BaseComponent implements OnInit {

    delegationPickerFormControl = new FormControl<UserDelegation | null>(null);

    constructor(protected readonly cdr: ChangeDetectorRef,
                private readonly dialogRef: KalDialogRef<UserDelegationPickerDialogComponent>,
                @Inject(KAL_DIALOG_DATA) private readonly data: UserDelegationPickerDialogData) {
        super(cdr);
    }

    close(): void {
        this.dialogRef.close({accepted: false});
    }

    /**
     * Si la délégation sélectionnée est identique à la délégation actuellement stockée dans les données de la dialog.
     */
    get isSelectionIdenticalToDialogData(): boolean {
        return isEqual(this.delegationPickerFormControl.value, this.data.currentDelegationData);
    }

    saveDelegation(): void {
        if (this.delegationPickerFormControl.invalid) {
            return;
        }

        this.loading = true;
        this.watch$ = this.dispatch$(new SaveUserLoginInformationsAction(this.delegationPickerFormControl.value)).pipe(
            switchMap(() => this.dispatch$(new GetFunctionalitiesAndWidgetsAccessibleAction())),
            tap(() => {
                this.loading = false;
                this.dialogRef.close({accepted: true});
            }),
            catchError(err => {
                this.loading = false;
                return throwError(err);
            })
        );
    }

    ngOnInit(): void {
        if(!!this.data.currentDelegationData) {
            this.delegationPickerFormControl.patchValue(this.data.currentDelegationData, {emitEvent: false});
        }
    }
}
